import React, { useEffect, useState } from "react";
import IconHeading from "../../Icons/IconHeading";
import GoogleMapsAPILoader from "../../shared/GoogleMapsAPILoader/GoogleMapsAPILoader";
import apiGet from "../../shared/api/apiGet";
import {
  ENDPOINT_CHARTER_BOOK,
  ENDPOINT_CHARTER_CONFIGS,
  ENDPOINT_CHARTER_SEARCH,
  ENDPOINT_CONFIGS
} from "../../shared/consts/apiConsts";
import {INBOUND, ONE_WAY_TRIP, OUTWARD, RETURN_TRIP} from "../../shared/consts/bookingConsts";
import Loading from "../../shared/Loader/Loading";
import TripSection from "../../shared/BookingPage/TripSection/TripSection";
import apiPost from "../../shared/api/apiPost";
import duplicatePax from "../../shared/duplicatePax/duplicatePax";
import moneyFormat from "../../shared/MoneyFormat/moneyFormat";

const QuoteRequestPage = () => {

  const params = new URLSearchParams(window.location.search);

  const readURLParam = (name, def) => {
    const val = params.get(name);
    return val ? val : def;
  }

  const [token, setToken] = useState(readURLParam('token', null));
  const [id, setID] = useState(readURLParam('id', null));
  const [bookingType, setBookingType] = useState(readURLParam('type', ONE_WAY_TRIP));
  const [canBook, setCanBook] = useState(null);
  const [total, setTotal] = useState(null);
  const [subTotal, setSubTotal] = useState(null);
  const [gst, setGST] = useState(null);

  const [configs, setConfigs] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [emailing, setEmailing] = useState(false);
  const [success, setSuccess] = useState(false);

  const [name, setName] = useState(readURLParam('name', ''));
  const [phone, setPhone] = useState(readURLParam('phone', ''));
  const [email, setEmail] = useState(readURLParam('email', ''));
  const [notes, setNotes] = useState(readURLParam('notes', ''));

  const [outStartLat, setOutStartLat] = useState(readURLParam('os_lat', ''));
  const [outStartLng, setOutStartLng] = useState(readURLParam('os_lng', ''));
  const [outStartAddress, setOutStartAddress] = useState(readURLParam('os_add', ''));

  const [outEndLat, setOutEndLat] = useState(readURLParam('oe_lat', ''));
  const [outEndLng, setOutEndLng] = useState(readURLParam('oe_lng', ''));
  const [outEndAddress, setOutEndAddress] = useState(readURLParam('oe_add', ''));

  const [outPax, setOutPax] = useState(readURLParam('outPax', false)
    ? JSON.parse(readURLParam('outPax', '[]')) : []);
  const [outDate, setOutDate] = useState(readURLParam('outDate', null));
  const [outTime, setOutTime] = useState(readURLParam('outTime', null));

  const [outNoFlight, setOutNoFlight] = useState(false);
  const [outTerminal, setOutTerminal] = useState(readURLParam('outTerminal', false));
  const [outAirport, setOutAirport] = useState(!!readURLParam('outAirline', false));
  const [outAirline, setOutAirline] = useState(readURLParam('outAirline', null));
  const [outFlightNumber, setOutFlightNumber] = useState(readURLParam('outFlightNumber', null));
  const [outFlightTime, setOutFlightTime] = useState(readURLParam('outFlightTime', null));

  // inward data
  const [inStartLat, setInStartLat] = useState(readURLParam('is_lat', ''));
  const [inStartLng, setInStartLng] = useState(readURLParam('is_lng', ''));
  const [inStartAddress, setInStartAddress] = useState(readURLParam('is_add', ''));

  const [inEndLat, setInEndLat] = useState(readURLParam('ie_lat', ''));
  const [inEndLng, setInEndLng] = useState(readURLParam('ie_lng', ''));
  const [inEndAddress, setInEndAddress] = useState(readURLParam('ie_add', ''));

  const [inPax, setInPax] = useState(readURLParam('inPax', false)
    ? JSON.parse(readURLParam('inPax', '[]')) : []);
  const [inDate, setInDate] = useState(readURLParam('inDate', null));
  const [inTime, setInTime] = useState(readURLParam('inTime', null));

  const [inNoFlight, setInNoFlight] = useState(false);
  const [inTerminal, setInTerminal] = useState(!!readURLParam('inTerminal', false));
  const [inAirport, setInAirport] = useState(!!readURLParam('inAirline', false));
  const [inAirline, setInAirline] = useState(readURLParam('inAirline', null));
  const [inFlightNumber, setInFlightNumber] = useState(readURLParam('inFlightNumber', null));
  const [inFlightTime, setInFlightTime] = useState(readURLParam('inFlightTime', null));

  const [controller, setController] = useState(undefined);


  useEffect(() => {
    apiGet(ENDPOINT_CHARTER_CONFIGS).then((results) => {
      setConfigs(results);
      setOutPax(duplicatePax(results.types, outPax));
      setInPax(duplicatePax(results.types, inPax));
      if (results.name) {
        setName(results.name);
      }
      if (results.email) {
        setEmail(results.email);
      }
      if (results.phone) {
        setPhone(results.phone);
      }
    });
  }, []);

  useEffect(() => {
    if (validatePostData(false)) {
      performSearch()
    }
  }, [outStartLng, outEndLng, inStartLng, inEndLng, outPax, inPax, outTime, inTime]);

  const getPostData = () => {
    return {
      bookingType: bookingType,

      name: name,
      email: email,
      phone: phone,
      notes: notes,

      outStart: [outStartLng, outStartLat, outStartAddress],
      outEnd: [outEndLng, outEndLat, outEndAddress],
      outPax: outPax,
      outDate: outDate,
      outTime: outTime,


      inStart: [inStartLng, inStartLat, inStartAddress],
      inEnd: [inEndLng, inEndLat, inEndAddress],
      inPax: inPax,
      inDate: inDate,
      inTime: inTime,

      outFlightTime: outNoFlight ? '' : outFlightTime,
      outFlightNumber: outNoFlight ? '' : outFlightNumber,
      outAirline: outNoFlight ? '' : outAirline,
      outTerminal: outNoFlight ? '' : outTerminal,

      inFlightTime: inNoFlight ? '' : inFlightTime,
      inFlightNumber: inNoFlight ? '' : inFlightNumber,
      inAirline: inNoFlight ? '' : inAirline,
      inTerminal: inNoFlight ? '' : inTerminal,

      submit: true,
    }
  }

  const performSearch = () => {
    let body = getPostData();
    apiPost(
      ENDPOINT_CHARTER_SEARCH,
      body,
      undefined,
      handleAbortController()
    ).then((response) => {
      setLoading(false);
      setCanBook(response.can);
      setTotal(response.total);
      setSubTotal(response.sub_total);
      setGST(response.gst);
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let body = getPostData();
    body.submit = e.nativeEvent.submitter.name === 'submit';

    if (body.submit) {
      setLoading(true);
    } else {
      setEmailing(true);
    }
    apiPost(
      ENDPOINT_CHARTER_BOOK,
      body,
      undefined,
      handleAbortController()
    ).then((response) => {
      if (body.submit) {
        setSuccess(response.success);
      }
      setLoading(false);
      setEmailing(false);
      if (response.redirect_url) {
        window.location = response.redirect_url;
      }
    })
  }

  const handleAbortController = () => {
    if (controller) {
      controller.abort();
    }
    const ctrl = new AbortController();
    setController(ctrl);
    return ctrl;
  }

  const updateBookingType = (type) => {
    setBookingType(type);
    setInDate(null);
    setInTime(null);
    setInStartLng(type === RETURN_TRIP ? outEndLng : '');
    setInStartLat(type === RETURN_TRIP ? outEndLat : '');
    setInStartAddress(type === RETURN_TRIP ? outEndAddress : '');
    setInEndLng(type === RETURN_TRIP ? outStartLng : '');
    setInEndLat(type === RETURN_TRIP ? outStartLat : '');
    setInEndAddress(type === RETURN_TRIP ? outStartAddress : '');
    setInPax(type === RETURN_TRIP ? duplicatePax(outPax) : []);
    setInAirport(type === RETURN_TRIP ? outAirport : false);
    setInTerminal('');
    setInAirline('');
    setInFlightNumber('');
    setInFlightTime('');
  }

  const selectedPax = (pax) => {
    let valid = false;
    pax.map((item) => {
      if (item.value > 0) {
        valid = true;
      }
    })
    return valid;
  }

  const validatePostData = (strict) => {
    let valid = true;
    if (!(outStartLng && outEndLng && outTime)) {
      console.log('E1')
      valid = false;
    }
    if (bookingType === RETURN_TRIP && !(inStartLng && inEndLng)) {
      console.log('E2')
      valid = false;
    }
    if (!selectedPax(outPax)) {
      console.log('E3')
      valid = false;
    }
    if (bookingType === RETURN_TRIP && !selectedPax(inPax)) {
      console.log('E4')
      valid = false;
    }

    if (strict) {
      if (!name) {
        valid = false;
        console.log('E5')
      }
      if (!phone) {
        valid = false;
        console.log('E6')
      }
      if (!email) {
        valid = false;
        console.log('E7')
      }
      if (outAirport && !outNoFlight && (!outAirline || !outFlightTime || !outFlightNumber)) {
        valid = false;
        console.log('E8')
      }
      if (bookingType === RETURN_TRIP && inAirport && !inNoFlight && (!inAirline || !inFlightTime || !inFlightNumber)) {
        valid = false;
        console.log('E9')
      }
    }
    return valid;
  }

  if (!configs) {
    return <div className="booking bookingPage">
      <div className="container">
        <div className="booking__wrap">
          <Loading />
        </div>
      </div>
    </div>
  }

  if (success) {
    return <div className="booking bookingPage">
      <div className="container">
        <div className="booking__wrap">
          <div className="booking__getQuote__submitted">
            <div
              className="submitted__left"
              dangerouslySetInnerHTML={{__html: configs.bookingSuccess}}
            />
            <div className="submitted__right">
              <a href="" className="btn btn--lg">CONTACT US</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  }


  return <GoogleMapsAPILoader>
    <form
      onSubmit={handleSubmit}
    >
      <div className="booking bookingPage">
        <div className="container">
          <div className="booking__wrap">
            <TripSection
              tripType={OUTWARD}
              bookingType={bookingType}
              startAddress={outStartAddress}
              endAddress={outEndAddress}
              airlines={configs.airlines}
              pax={outPax}
              date={outDate}
              time={outTime}
              terminal={outTerminal}
              airport={outAirport}
              airline={outAirline}
              showTerminal={!!outTerminal}
              flightNumber={outFlightNumber}
              flightTime={outFlightTime}
              noFlight={outNoFlight}
              setStartLat={setOutStartLat}
              setStartLng={setOutStartLng}
              setStartAddress={setOutStartAddress}
              setEndLat={setOutEndLat}
              setEndLng={setOutEndLng}
              setEndAddress={setOutEndAddress}
              setAirport={setOutAirport}
              setPax={setOutPax}
              setDate={setOutDate}
              setTime={setOutTime}
              setTerminal={setOutTerminal}
              setBookingType={updateBookingType}
              setAirline={setOutAirline}
              setFlightNumber={setOutFlightNumber}
              setFlightTime={setOutFlightTime}
              showTime={true}
              setNoFlight={setOutNoFlight}
            />

            {bookingType === RETURN_TRIP && <>
              <TripSection
                tripType={INBOUND}
                bookingType={bookingType}
                startAddress={inStartAddress}
                endAddress={inEndAddress}
                airlines={configs.airlines}
                pax={inPax}
                outDate={outDate}
                date={inDate}
                time={inTime}
                terminal={inTerminal}
                airport={inAirport}
                airline={inAirline}
                flightNumber={inFlightNumber}
                flightTime={inFlightTime}
                noFlight={inNoFlight}
                setStartLat={setInStartLat}
                setStartLng={setInStartLng}
                setStartAddress={setInStartAddress}
                setAirport={setInAirport}
                setEndLat={setInEndLat}
                setEndLng={setInEndLng}
                setEndAddress={setInEndAddress}
                setPax={setInPax}
                setDate={setInDate}
                setTime={setInTime}
                setTerminal={setInTerminal}
                setBookingType={updateBookingType}
                setAirline={setInAirline}
                setFlightNumber={setInFlightNumber}
                setFlightTime={setInFlightTime}
                showTime={true}
                setNoFlight={setInNoFlight}
              />
            </>}

            <div className="booking__section">
              <div className="booking__yourDetail">
                <div className="booking__title">
                  <div className="booking__headIcon">
                    <IconHeading />
                  </div>
                  <h3>Contact Details</h3>
                </div>
              </div>
              <div className="booking__yourDetail__inputs booking__section__inputs">
                <div className="booking__yourDetail__input booking__section__input input--md">
                  <label>Full name</label>
                  <input
                    required={true}
                    aria-labelledby="name"
                    type="text"
                    value={name}
                    onChange={(e) => { setName(e.target.value) }}
                  />
                </div>
                <div className="booking__yourDetail__input booking__section__input input--md">
                  <label>Email</label>
                  <input
                    required={true}
                    aria-labelledby="email"
                    type="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value) }} />
                </div>
                <div className="booking__yourDetail__input booking__section__input input--md">
                  <label>Phone</label>
                  <input
                    required={true}
                    type="text"
                    aria-labelledby="phone"
                    value={phone}
                    onChange={(e) => { setPhone(e.target.value) }} />
                </div>
              </div>
            </div>
            <div className="booking__section">
              <div className="booking__additionalDetail">
                <div className="booking__title">
                  <div className="booking__headIcon">
                    <IconHeading />
                  </div>
                  <h3>Additional Information</h3>
                </div>
                <p>
                  Please tell us a little about your transfer requirements, such as additional luggage or special
                  requests you might have.<br />
                  Included with your booking is one standard-size suitcase and one small carry-on suitcase.
                  If you have extra or oversized luggage, please indicate this as below.<br />
                  <i>
                    Please note that failure to declare additional or oversized luggage may result in our team
                    being unable to transport your belongings.
                  </i>
                </p>

              </div>
              <div className="booking__additionalDetail__inputs booking__section__inputs">
                <div className="booking__additionalDetail__input booking__section__input">
                  <textarea
                    name={'notes'}
                    value={notes}
                    onChange={(e) => {setNotes(e.target.value)}} rows={7} />
                </div>
              </div>
            </div>
            {canBook === false && <>
              <div className="booking__getQuote__submitted">
                <div
                  className="submitted__left"
                  dangerouslySetInnerHTML={{__html: configs.bookingError}}
                />
                <div className="submitted__right">
                  <a href="/contact-us" className="btn btn--lg">CONTACT US</a>
                </div>
              </div>
            </>}
            {canBook && <>
              <div className="booking__section">
                <div className="booking__total">
                  <div className="booking__total__left typography">
                    <p className="h3">Sub total</p>
                  </div>
                  <div className="booking__total__right typography">
                    <p className="h3">{`${moneyFormat(subTotal)}`}</p>
                  </div>
                </div>
                <div className="booking__total">
                  <div className="booking__total__left typography">
                    <p className="h3">GST</p>
                  </div>
                  <div className="booking__total__right typography">
                    <p className="h3">{`${moneyFormat(gst)}`}</p>
                  </div>
                </div>
                <div className="booking__total">
                  <div className="booking__total__left typography">
                    <p className="h3">Estimated total including taxes and charges</p>
                  </div>
                  <div className="booking__total__right typography">
                    <p className="h2">{`NZD ${moneyFormat(total)}`}</p>
                  </div>
                </div>
              </div>
            </>}
            {canBook !== false && <div className="booking__getQuote__actions">
              <div className="booking__getQuote__action">
                <button
                  disabled={!validatePostData(true) || !canBook || loading || emailing}
                  name={'save'}
                  type={'submit'}
                  className="btn btn--hollow btn--lg">{emailing ? <Loading /> : 'Save Quote'}</button>
              </div>
              <div className="booking__getQuote__action">
                <button
                  disabled={!validatePostData(true) || !canBook || loading || emailing}
                  name={'submit'}
                  type={'submit'}
                  className="btn btn--lg">{loading ? <Loading /> : 'Request Booking'}</button>
              </div>
            </div>}
          </div>
        </div>
      </div>
    </form>
  </GoogleMapsAPILoader>;
};

export default QuoteRequestPage;
